import type { TFunction } from 'i18next';

export const getGradeLevels = (t: TFunction) => [
  { value: '', label: t('register.selectGrade') },
  { value: '5', label: t('register.grade', { number: '5' }) },
  { value: '6', label: t('register.grade', { number: '6' }) },
  { value: '7', label: t('register.grade', { number: '7' }) },
  { value: '8', label: t('register.grade', { number: '8' }) },
];
